import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import App from "./App";
import NotFound from "./components/NotFound";
import ProDashboard from "./components/ProDashboard";
import BgRemover from "./components/BgRemover/BgRemover";
import ImageEnhancer from "./components/ImageEnhancer/ImageEnhancer";
import ImageColorizer from "./components/ImageColorizer/ImageColorizer";
import SuperResolution from "./components/superResolution/superResolution";
import FaceWrap from "./components/FaceWrap/FaceWrap";
import AiSelfieGenerator from "./components/AiSelfieGenerator/AiSelfieGenerator";
import AiExpandImages from "./components/AiExpandImages/AiExpandImages";
import BgChanger from "./components/BgChanger/BgChanger";
import AIImageGenerator from "./components/Pages/AIImageGenerator/AIImageGenerator";
import AIBackgroundRemover from "./components/Pages/AIBackgroundRemover/AIBackgroundRemover";
import AIBackgroundChanger from "./components/Pages/AIBackgroundChanger/AIBackgroundChanger";
import AIImageEnhancer from "./components/Pages/AIImageEnhancer/AIImageEnhancer";
import AIImageColorizer from "./components/Pages/AIImageColorizer/AIImageColorizer";
import AISuperResolution from "./components/Pages/AISuperResolution/AISuperResolution";
import AIFaceWrap from "./components/Pages/AIFaceWrap/AIFaceWrap";
import AISelfieGenerator from "./components/Pages/AISelfieGenerator/AISelfieGenerator";
import AIImageExpand from "./components/Pages/AIImageExpand/AIImageExpand";
import ContactUs from "./components/ContactUs";

const AppRoutes = () => {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<App />} />
        <Route path="/dashboard" element={<ProDashboard />} />
        <Route
          path="/dashboard/ai-background-remover"
          element={<BgRemover />}
        />
        <Route
          path="/dashboard/ai-background-changer"
          element={<BgChanger />}
        />
        <Route
          path="/dashboard/ai-image-enhancer"
          element={<ImageEnhancer />}
        />
        <Route
          path="/dashboard/ai-image-colorizer"
          element={<ImageColorizer />}
        />
        <Route
          path="/dashboard/ai-super-resolution"
          element={<SuperResolution />}
        />
        <Route path="/dashboard/ai-face-wrap" element={<FaceWrap />} />
        <Route
          path="/dashboard/ai-selfie-generator"
          element={<AiSelfieGenerator />}
        />
        <Route
          path="/dashboard/ai-expand-images"
          element={<AiExpandImages />}
        />
        {/* //Page// */}
        <Route
          path="/ai-background-remover"
          element={<AIBackgroundRemover />}
        />
        <Route
          path="/ai-background-changer"
          element={<AIBackgroundChanger />}
        />
        <Route path="/ai-image-enhancer" element={<AIImageEnhancer />} />
        <Route path="/ai-image-colorizer" element={<AIImageColorizer />} />
        <Route path="/ai-super-resolution" element={<AISuperResolution />} />
        <Route path="/ai-face-wrap" element={<AIFaceWrap />} />
        <Route path="/ai-selfie-generator" element={<AISelfieGenerator />} />
        <Route path="/ai-expand-images" element={<AIImageExpand />} />
        <Route path="/ai-image-generator" element={<AIImageGenerator />} />
        <Route path="/contact-us" element={<ContactUs />} />
        <Route path="*" element={<NotFound />} /> {/* 404 Page */}
      </Routes>
    </Router>
  );
};

export default AppRoutes;
